import { Node, mergeAttributes } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import { TitleNodeView } from "@/components/editor/nodeviews/TitleNodeView";

/**
 * Title page block — LaTeX \title / \author / \date consumed into preamble
 * +\maketitle. Atom node with modal editing (see TitleNodeView).
 */
export const TitleBlock = Node.create({
  name: "titleBlock",
  group: "block",
  atom: true,

  addAttributes() {
    return {
      blockId: { default: null },
      title: { default: "" },
      author: { default: "" },
      /** "today" | "fixed" — when missing (""), inferred from `date`. */
      dateMode: { default: "" },
      /** "\\today", ISO yyyy-mm-dd, or free text. */
      date: { default: "\\today" },
      /** Keywords (publisher templates, 25 Oct 2026): each class prints them its own way (\\keywords, IEEEkeywords…). */
      keywords: { default: [] as string[] },
      /** ACM's TAPS (phase 3, 25 Oct 2026): CCS concepts and the rights block, pasted as ACM's tools give them. */
      acmCcs: { default: "" },
      acmRights: { default: "" },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-type="title-block"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(HTMLAttributes, { "data-type": "title-block" })];
  },

  addNodeView() {
    // Only intercept mousedown so PM doesn't select-only on first click.
    // Do NOT stop all clicks — that breaks Save/Cancel on the portaled modal.
    return ReactNodeViewRenderer(TitleNodeView, {
      stopEvent: ({ event }) =>
        event.type === "mousedown" || event.type === "pointerdown",
    });
  },
});
